import "../styles/home.css";

const Home = () => {
  return (
    <div id="imageWrapper">
      <a href="https://www.youtube.com/watch?v=r90GS1Go1gc" target="blank" >
        <img
          id="coverphoto"
          src="/images/cover.png"
          alt="Wilma Hultén live set"
        />
      </a>
    </div>
  );
};

export default Home;
